module.exports = __webpack_public_path__ + "static/img/footer-QR.07207b1d.png";